// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.actions-spacer[data-v-2e7c3b4f] {\n  display: inline-block;\n  width: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
